import _toConsumableArray from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/toConsumableArray.js";
import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["options", "selectedOptions", "setChecked", "required", "errors", "handleErrorClear"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Checkbox, FormControl, FormControlLabel, FormGroup, FormHelperText } from '@mui/material';
import * as A from 'fp-ts/Array';
import * as B from 'fp-ts/boolean';
import * as Eq from 'fp-ts/Eq';
import { constant, flow, pipe } from 'fp-ts/function';
import { Controller } from 'react-hook-form';
import { Translation } from 'react-i18next';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var CheckBoxGroupFormField = function CheckBoxGroupFormField(_ref) {
  var options = _ref.options,
      selectedOptions = _ref.selectedOptions,
      setChecked = _ref.setChecked,
      required = _ref.required,
      _ref$errors = _ref.errors,
      errors = _ref$errors === void 0 ? false : _ref$errors,
      handleErrorClear = _ref.handleErrorClear,
      controllerProps = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_jsxs(FormControl, {
    required: true,
    error: errors,
    "data-element": "FormControl",
    "data-component": "CheckBoxGroupFormField",
    "data-source-file": "checkbox-group-form-field.tsx",
    children: [/*#__PURE__*/_jsx(FormGroup, {
      sx: {
        my: -0.75
      },
      "data-element": "FormGroup",
      "data-component": "CheckBoxGroupFormField",
      "data-source-file": "checkbox-group-form-field.tsx",
      children: options.map(function (option, index) {
        return /*#__PURE__*/_jsx(FormControlLabel, {
          label: option.label,
          control: /*#__PURE__*/_jsx(Controller, _objectSpread(_objectSpread({}, controllerProps), {}, {
            defaultValue: [],
            rules: _objectSpread(_objectSpread({}, controllerProps.rules), {}, {
              required: required
            }),
            render: function render(_ref2) {
              var field = _ref2.field;
              return /*#__PURE__*/_jsx(Checkbox, _objectSpread(_objectSpread({
                sx: {
                  ml: 2,
                  p: 0.5
                }
              }, field), {}, {
                onChange: flow(constant(selectedOptions), A.elem(Eq.eqStrict)(option.value), B.match(function () {
                  return (// eslint-disable-next-line @typescript-eslint/no-unsafe-return
                    [].concat(_toConsumableArray(selectedOptions !== null && selectedOptions !== void 0 ? selectedOptions : []), [option.value])
                  );
                }, function () {
                  return (// eslint-disable-next-line @typescript-eslint/no-unsafe-return
                    pipe(selectedOptions, A.filter(function (name) {
                      return name !== option.value;
                    }))
                  );
                }), function (newNames) {
                  return setChecked(newNames);
                }, handleErrorClear)
              }));
            }
          }))
        }, index);
      })
    }), errors && /*#__PURE__*/_jsx(FormHelperText, {
      sx: {
        mt: 1,
        ml: 0,
        color: function color(theme) {
          return theme.palette.error.main;
        }
      },
      children: /*#__PURE__*/_jsx(Translation, {
        children: function children(t) {
          return t('This field is required.');
        }
      })
    })]
  });
};

export default CheckBoxGroupFormField;